import { LitElement, html } from "lit";
import * as Sentry from "@sentry/browser";
import api from "../../api/index.js";
import tableStyles from "../../styles/tables.js";
import sharedStyles from "../../styles/shared.js";
import inputStyles from "../../styles/input.js";
import { DateFormatter } from "../../formatting/dateformats.js";
import { toast } from "../../utils.js";

export default class OrdersSellView extends LitElement {
	static get properties() {
		return {
			ordertypes: {
				type: Array,
			},
			order_id: {
				type: Number,
			},
			positions: {
				type: Array,
			},
		};
	}

	constructor() {
		super();
		this.rows = [];
		this.query = "";
		this.sellAmount = this.sellAmount.bind(this);
		this.getCustody = this.getCustody.bind(this);
		this.sellQuantity = this.sellQuantity.bind(this);
		this.qtyChange = this.qtyChange.bind(this);
		this.tradedate = DateFormatter.format(new Date(), "yyyy-mm-dd");
		this.positions = [];
	}

	render() {
		return html`
      ${sharedStyles}
      ${tableStyles}
      ${inputStyles}
      <style>
      :host {
        display: block;
        margin: 24px auto;
        max-width: 800px;
      }

      </style>
     
      <div class="card" >
      <div class="card-header">
       <h2 style="padding:10px;">Sell</h2>
       <div>Create Fund order to Sell specific units from a custody, or to sell units corresponding to a certain amount of money.</div>
       </div>
       <fm-form id = "parms" class="form-grid" @submit="${this.sellAmount}">
        <div class="form-field">
           <label>custody
              <fm-autocomplete url="/lov/custodies"  id="custody" @select="${
								this.getCustody
							}" name="custody_id" select="id" display="name" ></fm-autocomplete>
           </label>
         </div>
         <div class="form-field"> 
           <label>Fixed Amount of money 
            <input type="number" name="amount">
           </label>
          </div>
          <div class="form-field"> 
         </label>
           <fm-button type="submit" id="submit_button" class="btn" style="max-width:160px">Sell Fixed Amount</fm-button>
         </div>
      </fm-form>
      </div>
      ${this.renderPositions()}
      `;
	}

	renderPosition(r, i) {
		return html`
  <tr>
  <td>${r.name}</td>
  <td class="numeric">${r.quantity}</td>
  <td class="numeric"><input data-ix="${i}" type="number" @change="${this.qtyChange}" value="${r.sell}"></td>
  <td><fm-button type="button" style="max-width:80px" class="btn" data-ix="${i}" @click="${this.sellQuantity}">Sell Units</fm-button></td>
  </tr>
  `;
	}

	renderPositions() {
		return html`
  <div class="card-block">
  <table>
    <tr>
      <th>Security</th>
      <th class="numeric">Position</th>
      <th class="numeric">Sell Units</th>
      <th></th>
    </tr>
    ${(this.positions || []).map((r, i) => this.renderPosition(r, i))}
  </table>
  </div>
  `;
	}

	async sellAmount() {
		const parms = this.shadowRoot.querySelector("#parms").value;
		try {
			const data = await api.post("/orders/sellmoney", parms);
			toast(data.message);
		} catch (err) {
			Sentry.captureException(err);
			console.log(err);
		}
	}

	async getCustody() {
		const custody_id = this.shadowRoot.querySelector("#custody").value;
		const data = await api.get(`/custodies/${custody_id}/positions`);
		this.positions = data;
	}

	async sellQuantity(event) {
		const target = event.target;
		const ix = target.getAttribute("data-ix");
		const parms = this.shadowRoot.querySelector("#parms").value;
		parms.security_id = this.positions[ix].security_id;
		parms.quantity = this.positions[ix].sell;
		if (!parms.custody_id) {
			toast("Custody missing");
			return;
		}
		if (!parms.security_id) {
			toast("Security_id missing");
			return;
		}
		if (!parms.quantity) {
			toast("Quantity missing");
			return;
		}

		try {
			const data = await api.post("/orders/sell", parms);
			toast(data.message);
		} catch (err) {
			Sentry.captureException(err);
			toast("Fejl - ordren er ikke gennemført");
			console.log(err);
		}
	}

	async qtyChange(event) {
		const target = event.target;
		const ix = target.getAttribute("data-ix");
		if (ix) {
			this.positions[ix].sell = target.value;
		}
	}
}

customElements.define("orders-sell-view", OrdersSellView);
